import {ReactComponent as Logo} from '../assets/images/logo.svg';

const Header = () => {
  return (
    <div className="header">
        <Logo className="logo" />
        <div className="right">
          Project: Todo List
        </div>
    </div>
  );
}

export default Header;